var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolicitudes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3037_109035",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3037_109035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 38V34H42V38H18ZM18 26V22H42V26H18ZM18 14V10H42V14H18ZM10 40C8.9 40 7.95833 39.6083 7.175 38.825C6.39167 38.0417 6 37.1 6 36C6 34.9 6.39167 33.9583 7.175 33.175C7.95833 32.3917 8.9 32 10 32C11.1 32 12.0417 32.3917 12.825 33.175C13.6083 33.9583 14 34.9 14 36C14 37.1 13.6083 38.0417 12.825 38.825C12.0417 39.6083 11.1 40 10 40ZM10 28C8.9 28 7.95833 27.6083 7.175 26.825C6.39167 26.0417 6 25.1 6 24C6 22.9 6.39167 21.9583 7.175 21.175C7.95833 20.3917 8.9 20 10 20C11.1 20 12.0417 20.3917 12.825 21.175C13.6083 21.9583 14 22.9 14 24C14 25.1 13.6083 26.0417 12.825 26.825C12.0417 27.6083 11.1 28 10 28ZM10 16C8.9 16 7.95833 15.6083 7.175 14.825C6.39167 14.0417 6 13.1 6 12C6 10.9 6.39167 9.95833 7.175 9.175C7.95833 8.39167 8.9 8 10 8C11.1 8 12.0417 8.39167 12.825 9.175C13.6083 9.95833 14 10.9 14 12C14 13.1 13.6083 14.0417 12.825 14.825C12.0417 15.6083 11.1 16 10 16Z",
    fill: "#FFFFFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolicitudes);
export default __webpack_public_path__ + "static/media/solicitudes.a5d171ab1e93359b3fe696d7fa8185e8.svg";
export { ForwardRef as ReactComponent };